import React from 'react';

export const UnitContext = React.createContext({
    unit: 'Metric'
});

